import { USERS_ROUTES } from '@/views/Users/utils'
import {
  FormdataHistoryCollection as Data,
  getFormdataHistoryCategorySettings,
  getFormdataStatusText,
} from '@/typings/api/Formdata'

import { dateFormatter } from '@/helpers/dateFormatter'


export const TABLE_ACTIONS = Object.freeze([
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Тип',
    value: 'category',
    sortable: true,
    width: 280,
    field: (category: Data['category']) => (
      getFormdataHistoryCategorySettings(category).label
    ),
  },
  {
    text: 'Пользователь',
    value: 'user_username',
    sortable: true,
    width: 130,
    // TODO: ссылка не реализована в таблице
    getRoute: (data: Data) => ({
      name: USERS_ROUTES.VIEW,
      props: {
        id: data.user_id,
      },
    }),
  },
  {
    text: 'Дата изменения',
    value: 'created_at',
    sortable: true,
    width: 154,
    field: (value: Data['created_at']) => (
      value && dateFormatter(value, 'DD.MM.YYYY HH:mm:ss')
    ),
  },
  {
    text: 'Статус с',
    value: 'context.status_from',
    sortable: true,
    width: 100,
    field: (value: Data['status_from']) => (
      getFormdataStatusText(value)
    ),
  },
  {
    text: 'Статус на',
    value: 'context.status_to',
    sortable: true,
    width: 100,
    field: (value: Data['status_to']) => (
      getFormdataStatusText(value)
    ),
  },
])
